/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { GetTicketsByIdsDto } from '../../models/get-tickets-by-ids-dto';

export interface TicketControllerFindByIds$Params {
      body: GetTicketsByIdsDto
}

export function ticketControllerFindByIds(http: HttpClient, rootUrl: string, params: TicketControllerFindByIds$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BaseResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerFindByIds.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BaseResponse;
      }>;
    })
  );
}

ticketControllerFindByIds.PATH = '/ticket/by-ids';
